// The dates grid on the task screen. Each row (baseline, forecast, actual) is a
// start, a finish and a duration: change one and the others follow. Counting
// uses the engine's own calendar, so what the screen shows is what the server
// will schedule.
import { calendarDaysBetween } from '../../../../../src/lib/schedule.js';

/** Inclusive length of start to finish in the task's unit. Same day = 1. */
export function span(cal, start, finish, unit = 'workdays') {
  if (!start || !finish) return null;
  return unit === 'calendar' ? calendarDaysBetween(start, finish) + 1 : cal.workingDaysBetween(start, finish);
}

/**
 * Set one field of a { start, finish, duration } row and bring the others in
 * line. A duration moves the finish; a date recounts the duration. A half-typed
 * value (an empty duration, a finish before the start) leaves the rest alone.
 */
export function retime(row, field, value, cal, unit = 'workdays') {
  const next = { ...row, [field]: value };
  if (field === 'duration') {
    if (next.start && Number(value) > 0) next.finish = cal.finishFromStart(next.start, value, unit);
  } else if (next.start && next.finish) {
    const n = span(cal, next.start, next.finish, unit);
    if (n > 0) next.duration = n;
  } else if (field === 'start' && next.start && Number(next.duration) > 0) {
    next.finish = cal.finishFromStart(next.start, next.duration, unit);
  }
  return next;
}

/** What is wrong with a start and finish pair, or null. */
export function pairError({ start, finish }) {
  if (finish && !start) return 'finish needs a start';
  if (start && finish && finish < start) return 'finish is before the start';
  return null;
}

/**
 * Finish-to-start predecessors that had not finished by the day this task
 * actually started. Starting the same day is allowed, and a lead (negative
 * lag) is an overlap somebody planned, so neither is flagged.
 */
export function predecessorClashes(actualStart, predecessors, tasks) {
  if (!actualStart) return [];
  const byId = new Map(tasks.map(t => [t.id, t]));
  return predecessors
    .filter(p => (p.dep_type || 'FS') === 'FS' && !(Number(p.lag_days) < 0))
    .map(p => byId.get(p.predecessor_id))
    .filter(t => t && (!t.actual_finish || actualStart < t.actual_finish));
}
